import strings from 'utils/strings'

import { COLLET_COLORS } from 'utils/constants'

export const colletColors = {
  [COLLET_COLORS.BROWN]: strings.brown,
  [COLLET_COLORS.BLUE]: strings.blue,
  [COLLET_COLORS.RED]: strings.red,
  [COLLET_COLORS.GREEN]: strings.green,
  [COLLET_COLORS.BLACK]: strings.black,
  [COLLET_COLORS.WHITE]: strings.white,
  [COLLET_COLORS.TAN]: strings.tan,
  [COLLET_COLORS.YELLOW]: strings.yellow,
  [COLLET_COLORS.SILVER]: strings.silver,
  [COLLET_COLORS.PURPLE]: strings.purple,
  [COLLET_COLORS.DARK_GREEN]: strings.dark_green,
  [COLLET_COLORS.ORANGE]: strings.orange,
}

export const colletColorsUpper = {
  [COLLET_COLORS.BROWN]: strings.brown_upper,
  [COLLET_COLORS.BLUE]: strings.blue_upper,
  [COLLET_COLORS.RED]: strings.red_upper,
  [COLLET_COLORS.GREEN]: strings.green_upper,
  [COLLET_COLORS.BLACK]: strings.black_upper,
  [COLLET_COLORS.WHITE]: strings.white_upper,
  [COLLET_COLORS.TAN]: strings.tan_upper,
  [COLLET_COLORS.YELLOW]: strings.yellow_upper,
  [COLLET_COLORS.SILVER]: strings.silver_upper,
  [COLLET_COLORS.PURPLE]: strings.purple_upper,
  [COLLET_COLORS.DARK_GREEN]: strings.dark_green_upper,
  [COLLET_COLORS.ORANGE]: strings.orange_upper,
}
